<template>
  <div class="property-dashboard-side-nav d-none d-lg-block">
    <!--    <div class="subtitle">-->
    <!--      DATA-->
    <!--    </div>-->
    <!--    <router-link-->
    <!--      class="btn btn-info me-0"-->
    <!--      aria-current="page"-->
    <!--      :to="{-->
    <!--        name: 'marketing_analytices',-->
    <!--        params: {-->
    <!--          propertyId: propertyId,-->
    <!--        },-->
    <!--      }"-->
    <!--    >-->
    <!--      Marketing Analytics-->
    <!--    </router-link>-->
    <div class="subtitle">ADVERTISING</div>
    <router-link
      class="btn btn-info me-0"
      aria-current="page"
      :to="{
        name: 'campaigns',
        params: {
          propertyId: propertyId,
        },
      }"
    >
      Ads Manager
    </router-link>
    <router-link
      class="btn btn-info me-0 mb-1"
      :class="{ 'router-link-active': isActive('parent') }"
      aria-current="page"
      :to="{
        name: 'report',
        params: {
          propertyId: propertyId,
        },
      }"
    >
      Ads Reporting
    </router-link>
    <div v-if="campaignId">
      <div class="sub-list ms-3">
        <router-link
          class="btn btn-light me-3"
          aria-current="page"
          :to="{
            name: 'ad_overview',
            params: {
              propertyId: propertyId,
              campaignId: campaignId,
            },
          }"
        >
          Ad Overview
        </router-link>
      </div>
      <div class="sub-list ms-3">
        <router-link
          class="btn btn-light me-3"
          aria-current="page"
          v-if="showLeadIntroUrl"
          :to="{
            name: 'leads_intro',
            params: {
              propertyId: propertyId,
              campaignId: campaignId,
            },
          }"
        >
          Leads
        </router-link>
        <router-link
          v-else
          class="btn btn-light me-3"
          aria-current="page"
          :to="{
            name: 'contacts_identified',
            params: {
              propertyId: propertyId,
              campaignId: campaignId,
            },
          }"
        >
          Leads
        </router-link>
      </div>
      <div class="sub-list ms-3">
        <router-link
          class="btn btn-light me-3"
          aria-current="page"
          v-if="showTopIntroUrl"
          :to="{
            name: 'top_tenant_intro',
            params: {
              propertyId: propertyId,
              campaignId: campaignId,
            },
          }"
        >
          Top Tenant Contacts
        </router-link>
        <router-link
          v-else
          class="btn btn-light me-3"
          aria-current="page"
          :to="{
            name: 'tenant_contacts',
            params: {
              propertyId: propertyId,
              campaignId: campaignId,
            },
          }"
        >
          Top Tenant Contacts
        </router-link>
      </div>
      <div class="sub-list ms-3">
        <router-link
          class="btn btn-light me-3"
          aria-current="page"
          :to="{
            name: 'tenant_demographics',
            params: {
              propertyId: propertyId,
              campaignId: campaignId,
            },
          }"
        >
          Tenant Demographics
        </router-link>
      </div>
    </div>
    <router-link
      class="btn btn-info me-0"
      aria-current="page"
      :to="{
        name: 'audiences',
        params: {
          propertyId: propertyId,
        },
      }"
    >
      Ads Audiences
    </router-link>

    <div class="subtitle">PRODUCT</div>
    <router-link
      class="btn btn-info me-0"
      aria-current="page"
      :to="{
        name: '3D_walkthru',
        params: {
          propertyId: propertyId,
        },
      }"
    >
      3D Walkthru
    </router-link>
    <router-link
      class="btn btn-info me-0"
      aria-current="page"
      :to="{
        name: 'video',
        params: {
          propertyId: propertyId,
        },
      }"
    >
      Video
    </router-link>
    <!-- <router-link
      class="btn btn-info me-0"
      aria-current="page"
      :to="{
        name: 'studio',
        params: {
          propertyId: propertyId,
        },
      }"
    >
      Studio
    </router-link> -->
    <router-link
      class="btn btn-info me-0"
      aria-current="page"
      :to="{
        name: 'contents',
        params: {
          propertyId: propertyId,
        },
      }"
    >
      Content
    </router-link>
  </div>
  <div
    class="offcanvas offcanvas-start d-block d-lg-none"
    tabindex="-1"
    id="offcanvasMenu"
    aria-labelledby="offcanvasExampleLabel"
  >
    <div class="offcanvas-header">
      <h5 class="offcanvas-title" id="offcanvasExampleLabel"></h5>
      <button
        type="button"
        class="btn-close text-reset"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
      ></button>
    </div>
    <div class="offcanvas-body">
      <div class="property-dashboard-side-nav">
        <div class="subtitle">ADVERTISING</div>
        <router-link
          class="btn btn-info router-btn"
          aria-current="page"
          :to="{
            name: 'campaigns',
            params: {
              propertyId: propertyId,
            },
          }"
        >
          Ads Manager
        </router-link>
        <router-link
          class="btn btn-info router-btn"
          aria-current="page"
          :to="{
            name: 'report',
            params: {
              propertyId: propertyId,
            },
          }"
        >
          Ads Reporting
        </router-link>
        <div v-if="campaignId">
          <div class="sub-list ms-3">
            <router-link
              class="btn btn-light me-3"
              aria-current="page"
              :to="{
                name: 'ad_overview',
                params: {
                  propertyId: propertyId,
                  campaignId: campaignId,
                },
              }"
            >
              Ad Overview
            </router-link>
          </div>
          <div class="sub-list ms-3">
            <router-link
              class="btn btn-light me-3"
              aria-current="page"
              v-if="showLeadIntroUrl"
              :to="{
                name: 'leads_intro',
                params: {
                  propertyId: propertyId,
                  campaignId: campaignId,
                },
              }"
            >
              Leads
            </router-link>
            <router-link
              v-else
              class="btn btn-light me-3"
              aria-current="page"
              :to="{
                name: 'contacts_identified',
                params: {
                  propertyId: propertyId,
                  campaignId: campaignId,
                },
              }"
            >
              Leads
            </router-link>
          </div>
          <div class="sub-list ms-3">
            <router-link
              class="btn btn-light me-3"
              aria-current="page"
              v-if="showTopIntroUrl"
              :to="{
                name: 'top_tenant_intro',
                params: {
                  propertyId: propertyId,
                  campaignId: campaignId,
                },
              }"
            >
              Top Tenant Contacts
            </router-link>
            <router-link
              v-else
              class="btn btn-light me-3"
              aria-current="page"
              :to="{
                name: 'tenant_contacts',
                params: {
                  propertyId: propertyId,
                  campaignId: campaignId,
                },
              }"
            >
              Top Tenant Contacts
            </router-link>
          </div>
          <div class="sub-list ms-3">
            <router-link
              class="btn btn-light me-3"
              aria-current="page"
              :to="{
                name: 'tenant_demographics',
                params: {
                  propertyId: propertyId,
                  campaignId: campaignId,
                },
              }"
            >
              Tenant Demographics
            </router-link>
          </div>
        </div>
        <router-link
          class="btn btn-info outer-btn"
          aria-current="page"
          :to="{
            name: 'audiences',
            params: {
              propertyId: propertyId,
            },
          }"
        >
          Ads Audiences
        </router-link>

        <div class="subtitle">PRODUCT</div>
        <router-link
          class="btn btn-info router-btn"
          aria-current="page"
          :to="{
            name: '3D_walkthru',
            params: {
              propertyId: propertyId,
            },
          }"
        >
          3D Walkthru
        </router-link>
        <router-link
          class="btn btn-info router-btn"
          aria-current="page"
          :to="{
            name: 'video',
            params: {
              propertyId: propertyId,
            },
          }"
        >
          Video
        </router-link>
        <!-- <router-link
          class="btn btn-info router-btn"
          aria-current="page"
          :to="{
            name: 'studio',
            params: {
              propertyId: propertyId,
            },
          }"
        >
          Studio
        </router-link> -->
        <router-link
          class="btn btn-info router-btn"
          aria-current="page"
          :to="{
            name: 'contents',
            params: {
              propertyId: propertyId,
            },
          }"
        >
          Content
        </router-link>
      </div>
    </div>
  </div>
</template>
<style lang="sass">
@use "@/assets/vars.sass" as *
.property-dashboard-side-nav
  width: 256px
  margin-right: 28px
  margin-left: 30px
  margin-top: 2em
  +laptop
    width: 150px
    margin-right: 20px
  .subtitle
    color: $LightGrey
    font-weight: 600
    font-size: 12px
    line-height: 15px
    padding: 16px 18px
  a
    text-align: left
    padding: 16px 18px
    background-color: transparent
    border: none
    display: block
    font-weight: 600
    font-size: 15px
    line-height: 19px
    &:hover
      background-color: $LighterGrey
    &.router-link-active
      background-color: $LighterGrey
      pointer-events: none
    +mobile
      font-size: 14px
  a.btn:active
    background-color: $LighterGrey
  .sub-list
    a
      text-align: left
      padding: 4.5px 13px
      background-color: transparent
      border: none
      display: block
      font-weight: 600
      font-size: 13px
      line-height: 16px
      &:hover
        text-decoration: underline
      &.router-link-active
        text-decoration: underline
        pointer-events: none
  .sub-list:first-child a
    padding-top: 16px
#offcanvasMenu
  width: 60%
</style>

<script>
import { useRoute } from "vue-router";
import { ref } from "vue";

export default {
  name: "PropertyDashboardSidebarNav",
  setup(props) {
    const route = useRoute();

    const isActive = (parentName) => {
      const childRoutes = [
        "ad_overview",
        "contacts_identified",
        "leads_intro",
        "tenant_contacts",
        "top_tenant_intro",
        "tenant_demographics",
      ];
      return childRoutes.includes(route.name);
    };
    return {
      isActive,
      showLeadIntroUrl: ref(true),
      showTopIntroUrl: ref(true),
    };
  },
  props: ["propertyId", "campaignId", "showLeadIntro", "showTopIntro"],
  computed: {},
  methods: {},
  mounted() {
    if (typeof this.showLeadIntro == "boolean") {
      this.showLeadIntroUrl = this.showLeadIntro;
    }
    if (typeof this.showTopIntro == "boolean") {
      this.showTopIntroUrl = this.showTopIntro;
    }
    var routerBtns = document.querySelectorAll(".router-btn");
    routerBtns.forEach((routerBtn) => {
      routerBtn.addEventListener("click", function (event) {
        var body = document.body;
        body.style.removeProperty("overflow");
        body.style.removeProperty("padding-right");
      });
    });
  },
};
</script>
